import { createFileRoute } from '@tanstack/react-router';
import { RegraFiscalListagem } from '@/features/regra-fiscal/page/listagem/RegraFiscalListagem';

export const Route = createFileRoute('/a/regra-fiscal/')({
    component: RegraFiscalListagem,
});
